import { Box, Item } from 'devextreme-react/box';
import { formatDate } from 'devextreme/localization';
import { useContext } from 'react';
import { Field } from '../../../../layouts';
import { PendingType } from '../../../../types/enums';
import { RetailOrderContext } from '../context/RetailOrderContext';
import ReleaseFromPendingButton from './ReleaseFromPendingButton';

export default function PendingOrderCard() {

	const { order } = useContext(RetailOrderContext);

	return (
		<>
			<div className='dx-card pending-order-card'>
				<Box>
					<Item ratio={0} baseSize={360}>
						<div className='card-content'>
							<Field label={'Order #'} >{order.details.roNumber}</Field>
							<Field label={'Customer Name'} >{order.details.customerName}</Field>
							<Field label={'Status'} >{order.details.orderStatus}</Field>
							<Field label={'Submit Date'} >{formatDate(new Date(order.details.roDate), 'shortDate')}</Field>
							<div className='static-text'>
								{order.details.pendingDays ? `The order has been pending for ${order.details.pendingDays} business day${order.details.pendingDays > 1 ? "s" : ""}.` : ""}
							</div>
						</div>
					</Item>
					<Item ratio={1}>
						<div className='card-header'>
							{
								order.details.pendingTypeID === PendingType.Customer ? "The job is pending due to the customer." :
									order.details.pendingTypeID === PendingType.Material ? "The job is pending due to the material." :
										"The job is pending due to the store."
							}
						</div>
						<div className='card-content field-label-30'>
							<Field label={'Reason'}>{order.details.pendingReason}</Field>
							<Field label={'Comment'}>{order.details.pendingComment}</Field>
							<Field label={'Set to Pending by'}>{order.details.setToPendingByName}</Field>
							<div className='static-text'>
								In order to progress the job, you must use the "Release From Pending" button.
							</div>
						</div>
					</Item>
					<Item ratio={0} baseSize={200}>
						<div className='card-content'>
							<ReleaseFromPendingButton />
						</div>
					</Item>
				</Box>
			</div>
		</>
	);
}
